import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@components/ui/dialog";
import { AuthModalProps } from "@models/auth.model";

export function AuthModal({ isOpen, onClose, title, children }: AuthModalProps) {

  return (
    <Dialog modal={true} open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent 
        className="bg-white md:max-w-3xl max-h-[90vh] overflow-y-auto mx-auto w-[90%] rounded-lg p-4"
        onPointerDownOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="flex flex-row items-center justify-between">
          <DialogTitle className="text-xl font-semibold">{title}</DialogTitle>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
